import { z } from "zod";
import { BalanceActions } from "src/Pages/Company/Absences/AbsenceRecords/AbsenceRecords.models";
import {
  EPatternUnit,
  EBillingCycleConfigurationType,
} from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";

export const createAbsenceRecordsModifyBalanceSchema = (
  billingCycleType?: EBillingCycleConfigurationType | null
) =>
  z
    .object({
      name: z.string(),
      year: z.string(),
      month: z.string().optional(),
      days: z
        .number({ message: "Liczba jest wymagana." })
        .min(0, "Liczba dni musi być większa lub równa 0.")
        .max(100, "Liczba dni nie może być większa niż 100.")
        .optional(),
      hours: z
        .number({ message: "Liczba jest wymagana." })
        .min(0, "Liczba godzin musi być większa lub równa 0.")
        .max(100, "Liczba godzin nie może być większa niż 100.")
        .optional(),
      operation: z.enum([BalanceActions.ADD, BalanceActions.REMOVE]),
      unit: z.enum(EPatternUnit),
      note: z.optional(
        z.string().max(255, "Notatka jest za długa, maksymalnie 255 znaków.")
      ),
    })
    .superRefine((data, ctx) => {
      if (data.unit === EPatternUnit.Day && data.days === undefined) {
        ctx.addIssue({
          code: "invalid_type",
          expected: "number",
          received: "undefined",
          path: ["days"],
          message: "Liczba jest wymagana.",
        });
      }
      if (data.unit === EPatternUnit.Hour && data.hours === undefined) {
        ctx.addIssue({
          code: "invalid_type",
          expected: "number",
          received: "undefined",
          path: ["hours"],
          message: "Liczba jest wymagana.",
        });
      }
    })
    .refine(
      (data) => {
        if (billingCycleType === EBillingCycleConfigurationType.Monthly) {
          return !!data.month;
        }
        return true;
      },
      {
        message:
          "Szablon wniosku rozliczany miesięcznie, wybierz miesiąc wprowadzanej zmiany.",
        path: ["month"],
      }
    );
